import { create } from 'zustand';

/** Shared battle state between PreBattle (lineup submission) and BattlePage (scene + rewards). */

export type BattleKind = 'campaign' | 'daily' | 'ladder' | 'friend';

interface BattleState {
  matchId: string | null;
  kind: BattleKind | null;
  result: unknown;
  lineupA: unknown;
  lineupB: unknown;
  /** For ladder: pts delta + new tier */
  ladderDelta: number | null;
  newTier: string | null;
  promoted: boolean;
  /** For daily: theme name + attempts left */
  themeName: string | null;
  attemptsLeft: number | null;
  setBattleResult: (payload: {
    matchId: string;
    kind: BattleKind;
    result: unknown;
    lineupA: unknown;
    lineupB: unknown;
    ladderDelta?: number;
    newTier?: string;
    promoted?: boolean;
    themeName?: string;
    attemptsLeft?: number;
  }) => void;
  clear: () => void;
}

export const useBattleStore = create<BattleState>(set => ({
  matchId: null,
  kind: null,
  result: null,
  lineupA: null,
  lineupB: null,
  ladderDelta: null,
  newTier: null,
  promoted: false,
  themeName: null,
  attemptsLeft: null,
  setBattleResult: (payload) =>
    set({
      matchId: payload.matchId,
      kind: payload.kind,
      result: payload.result,
      lineupA: payload.lineupA,
      lineupB: payload.lineupB,
      ladderDelta: payload.ladderDelta ?? null,
      newTier: payload.newTier ?? null,
      promoted: payload.promoted ?? false,
      themeName: payload.themeName ?? null,
      attemptsLeft: payload.attemptsLeft ?? null,
    }),
  clear: () =>
    set({
      matchId: null, kind: null, result: null, lineupA: null, lineupB: null,
      ladderDelta: null, newTier: null, promoted: false, themeName: null, attemptsLeft: null
    })
}));
